import { createFileRoute, redirect } from '@tanstack/react-router';
import EmployeePage from '../pages/EmployeePage';
import { getRoleRoute } from './index';
import { getProfileSync } from '../lib/getProfileSync';

export const Route = createFileRoute('/employee')({
  beforeLoad: () => {
    const profile = getProfileSync();
    if (!profile || profile.status !== 'active') {
      throw redirect({ to: '/' });
    }
    // Only Employee role lands here
    if (profile.role !== 'Employee') {
      throw redirect({ to: getRoleRoute(profile.role) });
    }
  },
  component: EmployeePage,
});
